// extracted by mini-css-extract-plugin
export default {"outerDiv":"units-page_outerDiv__iIQfg","addBtn":"units-page_addBtn__tnE27"};